import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocialAccountService {
  constructor(private http: HttpClient) {}

  // Fetch social account (party/contact mech)
  getSocialAccount(platform: string): Observable<any> {
    return this.http.get(`/api/party/contact-mech/${platform}`);  // Replace with actual endpoint
  }

  // Link a new social account
  linkSocialAccount(accountData: any): Observable<any> {
    return this.http.post('/api/party/contact-mech', accountData);  // Replace with actual endpoint
  }
}
